// extracted by mini-css-extract-plugin
export var copied = "ShareLink-module--copied--4a434";
export var shareLink = "ShareLink-module--share-link--14898";